export const categories = [
  {
    slug: "qingxin-xiezhen",
    name: "清新写真",
    description: "自然光下的纯美瞬间，白露清新风格的写真作品集，展现最自然真实的一面。",
  },
  {
    slug: "shishang-dapian",
    name: "时尚大片",
    description: "高级时装与创意造型的完美融合，白露时尚风格写真作品。",
  },
  {
    slug: "gudian-meiren",
    name: "古典美人",
    description: "汉服古装、旗袍等国风写真，白露演绎东方古典韵味。",
  },
  {
    slug: "heibai-jingdian",
    name: "黑白经典",
    description: "去掉色彩的干扰，用光影讲述故事，白露黑白写真作品集。",
  },
  {
    slug: "shinei-xiezhen",
    name: "室内写真",
    description: "精心布光的室内摄影作品，展现白露在不同场景中的表现力。",
  },
  {
    slug: "huwai-renshen",
    name: "户外人像",
    description: "大自然中的白露，户外环境人像摄影作品欣赏。",
  },
  {
    slug: "paishe-jiqiao",
    name: "拍摄技巧",
    description: "专业摄影技巧分享，从构图、布光到后期处理的全面解析。",
  },
  {
    slug: "moshi-gushi",
    name: "模特故事",
    description: "白露的职业发展历程、拍摄幕后花絮与行业感悟。",
  },
];

export const categoryGroups = [
  {
    name: "作品风格",
    slugs: ["qingxin-xiezhen", "shishang-dapian", "gudian-meiren", "heibai-jingdian", "shinei-xiezhen", "huwai-renshen"],
  },
  {
    name: "专业知识",
    slugs: ["paishe-jiqiao", "moshi-gushi"],
  },
];